/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIngress = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 16h6.435l2.399-3.984L8.433 8H2V6h7.567l2.436 4.074 2.432-4.038h4.222l-1.121-1.122L18.95 3.5l3.535 3.536-3.535 3.535-1.414-1.414 1.12-1.121h-3.09l-2.4 3.984 2.401 4.016h3.09l-1.122-1.122L18.95 13.5l3.535 3.535-3.535 3.536-1.415-1.414 1.122-1.122h-4.224l-2.436-4.074L9.565 18H2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIngress as Ingress };
